// src/hooks/use-door-state.ts

import { useEffect } from 'react';
import { useDoorContext } from '@/context/DoorContext';

const useDoorState = (setIsModalVisible: (visible: boolean) => void) => {
  // Get door state and updater functions from context
  const { isKillAIPressed, isKillAIReleased, setIsDoorOpen } = useDoorContext();

  // Update door open state and modal visibility based on AI kill signals
  useEffect(() => {
    if (isKillAIReleased) {
      setIsDoorOpen(true);
      setIsModalVisible(true);
    } else if (isKillAIPressed) {
      setIsDoorOpen(false);
      setIsModalVisible(false);
    }
  }, [isKillAIPressed, isKillAIReleased, setIsDoorOpen, setIsModalVisible]);
};

export default useDoorState;
